// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details[data-v-9567239e] {
  padding-top: 10px;
}
.details .base-info[data-v-9567239e] {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  row-gap: 16px;
  width: 100%;
}
.details .base-info .base-info-item[data-v-9567239e] {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 32%;
  color: #000;
}
.details .base-info .base-info-item[data-v-9567239e]:nth-child(3n -1) {
  margin: 0 2%;
}
.details .base-info .base-info-item .label[data-v-9567239e] {
  width: 142px;
  text-align: right;
  margin-right: 16px;
}
.details .base-info .base-info-item .value[data-v-9567239e] {
  height: 32px;
  flex: 1;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 6px;
  border: 1px solid #2a7ca7;
}
`, "",{"version":3,"sources":["webpack://./src/views/BigDataSoftware/HistoryData/Details.vue","webpack://./Details.vue"],"names":[],"mappings":"AACA;EACE,iBAAA;ACAF;ADDA;EAII,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;ACAJ;ADTA;EAWM,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;ACCN;ADAM;EACE,YAAA;ACER;ADpBA;EAqBQ,YAAA;EACA,iBAAA;EACA,kBAAA;ACER;ADzBA;EA0BQ,YAAA;EACA,OAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,yBAAA;ACER","sourcesContent":["\n.details {\n  padding-top: 10px;\n\n  .base-info {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    row-gap: 16px;\n    width: 100%;\n    .base-info-item {\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      flex-wrap: wrap;\n      width: 32%;\n      color: #000;\n      &:nth-child(3n -1) {\n        margin: 0 2%;\n      }\n      .label {\n        width: 142px;\n        text-align: right;\n        margin-right: 16px;\n      }\n      .value {\n        height: 32px;\n        flex: 1;\n        background-color: #f5f5f5;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        padding-left: 6px;\n        border: 1px solid #2a7ca7;\n      }\n    }\n  }\n}\n",".details {\n  padding-top: 10px;\n}\n.details .base-info {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  row-gap: 16px;\n  width: 100%;\n}\n.details .base-info .base-info-item {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  width: 32%;\n  color: #000;\n}\n.details .base-info .base-info-item:nth-child(3n -1) {\n  margin: 0 2%;\n}\n.details .base-info .base-info-item .label {\n  width: 142px;\n  text-align: right;\n  margin-right: 16px;\n}\n.details .base-info .base-info-item .value {\n  height: 32px;\n  flex: 1;\n  background-color: #f5f5f5;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-left: 6px;\n  border: 1px solid #2a7ca7;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
